import styled from 'styled-components';

export const RESULTS_FILTER_SLOT_ID = 'results-filter-slot';
export const RESULTS_FILTER_STRIP_HEIGHT = 68;

const searchBarStripPadding = props => {
  if (props.$compact && props.$compactExpanded) return '12px 24px 24px';
  if (props.$compact) return '0 24px 18px';
  return '28px 24px 26px';
};

const searchBarStripMarginTop = props => {
  if (props.$compact && !props.$compactExpanded) return '-10px';
  if (props.$compact) return '0';
  return '10px';
};

const searchBarStripPaddingMobile = props => {
  if (props.$compact && props.$compactExpanded) return '10px 12px 20px';
  if (props.$compact) return '0 12px 14px';
  return '16px 12px 24px';
};

const searchBarStripMarginTopMobile = props =>
  props.$compact && !props.$compactExpanded ? '-6px' : '0';

export const SearchBarStrip = styled.div`
  width: 100%;
  padding: ${searchBarStripPadding};
  margin-top: ${searchBarStripMarginTop};
  background: #fff;
  overflow: visible;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: ${searchBarStripPaddingMobile};
    margin-top: ${searchBarStripMarginTopMobile};
    overflow-x: hidden;
    overflow-y: visible;
    max-width: 100%;
  }
`;

export const ResultsFilterSlot = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  padding: 12px 0 16px;
  box-sizing: border-box;
  overflow: visible;

  .filter-scroll {
    --filter-chip-selected-bg: #f7f7f7;
    --filter-chip-selected-hover-bg: #f0f0f0;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    overflow-x: auto;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    > * {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      flex-wrap: nowrap;
      flex-shrink: 0;
    }

    h3 {
      display: none;
    }

    .drop-down {
      display: inline-flex;
      align-items: center;
      margin: 0;
      flex-shrink: 0;
    }

    .cuisine-filter {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
      gap: 8px;
      padding: 0;
      border: none;
      background: transparent;
      height: auto;
    }

    .ant-select {
      margin-bottom: 0 !important;
      flex-shrink: 0;

      .ant-select-selection {
        height: 36px;
        border-radius: 32px;
        border: 1px solid #b0b0b0;
        background: #fff;
        box-shadow: none;
        display: flex;
        align-items: center;
        transition: border-color 0.2s ease;
      }

      &:hover .ant-select-selection {
        border-color: #222;
      }

      .ant-select-selection__rendered {
        line-height: 34px;
        margin-left: 16px;
        margin-right: 16px;
      }

      .ant-select-selection-selected-value,
      .ant-select-selection__placeholder {
        color: #717171 !important;
        font-weight: 400;
        font-size: 12px !important;
      }

      .ant-select-selection-selected-value {
        color: #222 !important;
      }
    }

    .ant-btn,
    button.ant-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 32px;
      border: 1px solid #b0b0b0;
      background: #fff;
      color: #222;
      font-weight: 400;
      font-size: 12px;
      height: 36px;
      line-height: 34px;
      padding: 0 16px;
      box-shadow: none;
      flex-shrink: 0;
      transition: border-color 0.2s ease, background 0.2s ease;

      &:hover,
      &:focus {
        border-color: #222;
        color: #222;
        background: #fff;
      }

      &.filter-chip-selected,
      &.primary-btn {
        border-color: #222;
        background: var(--filter-chip-selected-bg);
        color: #222;
        font-weight: 500;

        &:hover,
        &:focus,
        &:active {
          border-color: #222;
          color: #222;
          background: var(--filter-chip-selected-hover-bg);
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 12px 8px 10px;

    .filter-scroll {
      justify-content: center;
      align-items: center;
      gap: 8px;
      padding-bottom: 2px;
      flex-wrap: wrap;
      overflow-x: hidden;
      overflow-y: visible;
    }

    .filter-scroll > * {
      flex-wrap: wrap;
      justify-content: center;
      max-width: 100%;
    }

    .cuisine-filter.cuisine-filter--selected {
      flex: 1 1 100%;
      width: 100%;
      max-width: 100%;
    }

    .ant-btn,
    button.ant-btn {
      height: 34px;
      line-height: 32px;
      padding: 0 12px;
      font-size: 12px;
    }

    .ant-btn,
    button.ant-btn {
      max-width: 100%;
      white-space: nowrap;
    }
  }
`;
